import { InMemoryCache, ApolloLink } from "apollo-boost";
import { cacheQueries } from "../queries/cache";
import { persistCache } from "apollo-cache-persist";
import { onError } from "apollo-link-error";

export const cache = new InMemoryCache();

export const waitOnCache = persistCache({
  cache,
  storage: window.localStorage
});

export const errorLink = onError(({ networkError, graphQLErrors }) => {
  if (graphQLErrors) {
    graphQLErrors.map(({ message, locations, path }) =>
      console.log(
        `[GraphQL error]: Message: ${message}, Location: ${locations}, Path: ${path}`
      )
    );
  }
  if (networkError) console.log(`[Network error]: ${networkError}`);
});

export const authMiddleware = new ApolloLink((operation, forward) => {
  // add the authorization to the headers
  const token = cache.readQuery({ query: cacheQueries.GET_TOKEN }).token;
  // const token = localStorage.getItem("token");

  operation.setContext({
    headers: {
      Authorization: token ? token : ""
    }
  });

  return forward(operation);
});

// initialize cache
cache.writeData({
  data: {
    language: "en",
    direction: "ltr"
  }
});
